import { PTStep } from 'enums/training.enums';
import { GroupRejectedReason } from 'lib_ts/enums/shot-rejection.enums';
import { PresetTrainingMode } from 'lib_ts/enums/training.enums';
import { IMachineState } from 'lib_ts/interfaces/i-machine-state';
import { ITrainingPitch } from 'lib_ts/interfaces/pitches';
import { IMachineShot } from 'lib_ts/interfaces/training/i-machine-shot';
import { IPresetTrainingSpec } from 'lib_ts/interfaces/training/i-preset-training-spec';

export interface IPastIteration {
  // for debugging, should be # adjustments +1
  index: number;
  ms: IMachineState;
  // easier to just record them here than re-fetch them from server
  // and then figure out which ones to exclude for aiming purposes
  matches: IMachineShot[];
  // we will look for the iteration with the lowest worstScore
  worstScore: number;

  // mode that was active at the time the iteration was saved
  mode: PresetTrainingMode;
  // spec that was active at the time the iteration was saved
  spec: Omit<IPresetTrainingSpec, 'minutesPerPitch'>;
  withinSpec: boolean;

  fireIDs: string[];
}

export interface IPTConfidenceThresholds {
  speed: number;
  breaks: number;
  spins: number;
}

export const CONF_THRESHOLDS_1: IPTConfidenceThresholds = {
  speed: 2.6,
  breaks: 14,
  spins: 450,
};

export const CONF_THRESHOLDS_2: IPTConfidenceThresholds = {
  speed: 1.5,
  breaks: 8,
  spins: 300,
};

export interface IPTNextStepRequest {
  target: ITrainingPitch;
  shots: IMachineShot[];
  iAdjustment: number; // which adjustment we are CURRENTLY on
}

export interface IPTNextStepResult {
  nextStep: PTStep;
  // when using a mode in PRECISE_PT_MODES and iterations are exhausted, a callout asks the user to retrain or continue
  showFailure: boolean;
  groupFilterResult: {
    reject: boolean;
    reasons: GroupRejectedReason[];
  };
  reason: string;
}
